import React, { Component } from "react";
import "./Login.css";
import { Auth } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import Confirmation from "./Confirmation";


export default class NewLogin extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      errorMsg: "",
      confirmAccount: false
    };
  }

  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event =>{

      this.setState({
          errorMsg: "",
         [event.target.id] : event.target.value
      });

  }


  handleSubmit = async event => {
    event.preventDefault();

    if(this.state.email.length === 0){
      this.setState({errorMsg: "Email cannot be empty."});
      return;
    }
    if(this.state.password.length === 0){
      this.setState({errorMsg: "Password cannot be empty."});
      return;
    }

    this.setState( { isLoading: true, errorMsg: "" } );
    try{
      var retVal = await Auth.signIn(this.state.email, this.state.password);
      this.props.userHasAuthenticated(true);
      this.props.history.push("/blogs");
    } catch(e){
      if(e.message === "User is not confirmed."){
        this.setState({isLoading: false, confirmAccount: true})
      }else{
        this.setState( {isLoading: false, errorMsg: e.message} );
      }

    }
  }

  render(){
    if(this.state.confirmAccount){
      return this.renderConfirmationForm();
    }else{
      return this.renderLoginForm();
    }
  }

  renderConfirmationForm(){
    return(
      <Confirmation email={this.state.email}
                     fullname={this.state.email}
                     password={this.state.password}
                     history={this.props.history}
                     shareDetails={false}
                     userHasAuthenticated={this.props.userHasAuthenticated}/>
    )
  }


  renderLoginForm(){
      var errorElement = this.state.errorMsg && this.state.errorMsg.length > 0
                              ? <div className="alert alert-danger" role="alert">
                                  {this.state.errorMsg}
                                </div>
                              : "";

      return (

          <div className="loginContainer">
                <div className="login-header retnet-yrsa-font">
                    <h4>LOGIN</h4>
                </div>
              {errorElement}
              <form className="form-default" role="form" onSubmit={this.handleSubmit} >
                  <div className="row">
                      <div className="col-12">
                          <div className="form-group">

                              <input type="email" id="email"
                                 value={this.state.email}
                                 onChange={this.handleChange}
                                 placeholder="Please enter your Email Id"
                                 className="form-control form-control-lg rounded" />
                          </div>
                      </div>
                  </div>

                  <div className="row">
                      <div className="col-lg-12">
                          <div className="form-group has-feedback">

                              <input type="password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    placeholder="Please enter your password"
                               className="form-control form-control-lg rounded" />
                          </div>
                      </div>
                  </div>

                  <LoaderButton block bsSize="large"
                               disabled = {!this.validateForm()}
                               type="submit"
                               isLoading={this.state.isLoading}
                               text="Login"
                               loadingText="Logging in..."
                               className="btn btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font"/>
                    <br />
                    <hr className="retnet-white-color"/>
                    <div className="text-center retnet-ysra-font">
                        <a href="/forgotpassword" className="btn  btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font" > Forgot Password </a>
                        <a href="/signup" className="btn  btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font" >Sign Up</a>

                    </div>
              </form>
          </div>



      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/NewLogin.js